module.exports = __webpack_public_path__ + "img/danmachi4.5a5dc167.jpg";